/**
 * Navigation Buttons
 * 
 * Unified navigation button rendering (prev/next/today) for date-based views.
 */

import { createButton } from './design-system.js';

export interface NavigationConfig {
  onPrev?: () => void;
  onNext?: () => void;
  onToday?: () => void;
  showToday?: boolean;
  centerContent?: string;
}

/**
 * Render navigation buttons (prev/next/today)
 */
export function renderNavigationButtons(config: NavigationConfig): string {
  const {
    onPrev,
    onNext,
    onToday,
    showToday = true,
    centerContent
  } = config;
  
  // Set up click handlers
  if (onPrev) {
    (window as any).__navPrev = () => onPrev();
  }
  if (onNext) {
    (window as any).__navNext = () => onNext();
  }
  if (onToday) {
    (window as any).__navToday = () => onToday();
  }
  
  const prevButton = createButton('←', {
    className: 'nav-prev',
    variant: 'ghost',
    onClick: onPrev ? 'window.__navPrev && window.__navPrev();' : undefined
  });
  
  const nextButton = createButton('→', {
    className: 'nav-next',
    variant: 'ghost',
    onClick: onNext ? 'window.__navNext && window.__navNext();' : undefined
  });
  
  const todayButton = showToday && onToday ? createButton('Today', {
    className: 'nav-today',
    variant: 'secondary',
    onClick: 'window.__navToday && window.__navToday();'
  }) : '';
  
  return `
    <div style="
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      padding: 0 8px;
    ">
      ${prevButton}
      ${centerContent ? `
        <h3 style="
          margin: 0;
          font-size: 14px;
          font-weight: 600;
          color: var(--ink, #ffffff);
        ">${centerContent}</h3>
      ` : '<div></div>'}
      <div style="display: flex; gap: 4px;">
        ${todayButton}
        ${nextButton}
      </div>
    </div>
  `;
}

